import {
  connect
} from 'react-redux'
import {getChannelCampaignList, saveCampaignGroup, getCampaignById, clearSaveCampaignErrorMessage} from '../../actions/Campaign'
import {selectClient} from "../../actions/App";
import CreateCampaignsView from '../../components/Campaigns/CreateCampaigns/CreateCampaigns'

const mapStateToProps = (state) => {
  const { emailChannelCampaigns, socialChannelCampaigns, onSavingCampaign, savingCampaignErrorMessage, 
    displayChannelCampaigns, campaignDetail } = state.campaigns;
  return {
    emailChannelCampaigns,
    socialChannelCampaigns,
    displayChannelCampaigns,
    client_id: state.app.client_info && state.app.client_info.id,
    client_tz: state.app.client_info && state.app.client_info.timezone,
    client_info: state.app.client_info,
    clients: state.app.clients,
    onSavingCampaign,
    savingCampaignErrorMessage,
    campaignDetail
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getChannelCampaigns(channel, startDate, endDate) {
      dispatch(getChannelCampaignList(channel, startDate, endDate));
    },

    saveCampaignGroup(data) {
      dispatch(saveCampaignGroup(data))
    },

    getCampaignById(id) {
      dispatch(getCampaignById(id, false))
    },

    selectClient(id) {
      dispatch(selectClient(id));
    },

    clearSaveCampaignErrorMessage(){
      dispatch(clearSaveCampaignErrorMessage());
    }
  }
}

const CreateCampaigns = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateCampaignsView)

export default CreateCampaigns;


// WEBPACK FOOTER //
// ./src/containers/Campaigns/createCampaigns.js